import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material'
import { FC, useState } from 'react'

import { CustomerEntry } from '../../sdk'
import { CustomerLookupInput } from '../CustomerLookUp'
import { PhoneNumberSelect } from '../PhoneNumberSelect'
import { TextFieldForLink } from '../TextFieldForLink'

interface Props {
  defaultMessage: string
  open: boolean
  handleCancel: () => void
  handleSend: () => void
  customer?: CustomerEntry
}

export const ShareViaSmsDialog: FC<Props> = ({
  defaultMessage,
  open,
  handleCancel,
  handleSend,
  customer,
  ...props
}) => {
  const [smsNumber, setSmsNumber] = useState<string | undefined>('')

  const [messageText, setMessageText] = useState<string | undefined>(
    defaultMessage
  )
  const handleClose = () => {
    setMessageText(defaultMessage)
    setSmsNumber(undefined)
    handleCancel()
  }
  return (
    <Dialog {...props} open={open} onClose={() => handleClose()}>
      <DialogTitle sx={{ fontWeight: 'bold' }}>Share via SMS</DialogTitle>
      <DialogContent sx={{ pb: 0 }}>
        <Typography pb={2}>
          Select customer, phone number, and type your message to send the SMS
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <CustomerLookupInput
            customer={customer}
            handleCustomerChange={() => {}}
            withNumber={false}
            isClickable={false}
          />

          {customer && (
            <PhoneNumberSelect
              customerId={customer.id!}
              number={smsNumber}
              handleNumberChange={(number) => setSmsNumber(number)}
            />
          )}
        </Box>
      </DialogContent>

      {customer && smsNumber && (
        <TextFieldForLink
          customer={customer}
          text={messageText}
          handleTextChange={(text) => setMessageText(text)}
          handleSend={handleSend}
          handleCancel={() => {
            setMessageText(defaultMessage)
            setSmsNumber(undefined)
            handleCancel()
          }}
          hasPreviousDialog={true}
        />
      )}

      {(!customer || !smsNumber) && (
        <DialogActions sx={{ pt: 2 }}>
          <Button variant="text" onClick={() => handleClose()}>
            Cancel
          </Button>
        </DialogActions>
      )}
    </Dialog>
  )
}
